module.exports = __webpack_public_path__ + "img/trx.4485ad0f.png";